import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { Observable } from 'rxjs';
import { combine } from 'src/app/shared/utilities/route';
import { Lookup } from 'src/app/shared/models/lookup.model';

@Injectable({ providedIn: 'root' })
export class FacilityVaccineService {
    private readonly _coreApiPath: string;

    constructor(private readonly _http: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this._coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getVaccineStatuses(): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/vaccination-statuses`;
        return this._http.get<Lookup[]>(url);
    }

    getVaccineTypes(): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/vaccination-types`;
        return this._http.get<Lookup[]>(url);
    }
}
